<div
  class="group flex gap-8 p-6 pl-8 hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
>
  <div class="flex flex-auto">
    <div
      class="flex flex-auto flex-col"
      [ngClass]="{ 'gap-3': !optionsForm() }"
    >
      @if (message().title) {
        <p
          class="text-default line-clamp-3 text-lg leading-snug opacity-80"
          [innerHTML]="message().title"
        ></p>
      }

      @if (optionsForm(); as form) {
        <form class="mt-3 flex w-full flex-col" [formGroup]="form">
          <mat-form-field class="flex-auto">
            <mat-select
              [placeholder]="activeButton()?.actionParams?.title ?? ''"
              formControlName="selectedOption"
            >
              @for (
                option of activeButton()?.actionParams?.options ?? [];
                track $index
              ) {
                <mat-option [value]="option">{{ option }}</mat-option>
              }
            </mat-select>
            <mat-error>
              @if (
                form.controls.selectedOption.touched &&
                form.controls.selectedOption.invalid
              ) {
                <app-validation-message
                  [field]="form.controls.selectedOption"
                ></app-validation-message>
              }
            </mat-error>
          </mat-form-field>
        </form>
        <div class="mt-2 flex w-full justify-between gap-3">
          <button
            mat-stroked-button
            class="text-base font-semibold"
            (click)="optionsForm.set(null)"
          >
            Cancel
          </button>
          <button
            mat-flat-button
            color="accent"
            class="flex-[1_0_0] text-base font-semibold"
            [disabled]="form.invalid || form.disabled"
            (click)="saveOption()"
          >
            @if (!form.disabled) {
              <span>Save</span>
            } @else {
              <mat-progress-spinner diameter="24" mode="indeterminate" />
            }
          </button>
        </div>
      } @else {
        <div class="actions flex gap-6">
          @if (message().actionButton) {
            <a
              class="cursor-pointer text-base font-medium text-link underline"
              (click)="
                onClick(message().body ? 'detailsButton' : 'actionButton')
              "
              tabindex="0"
              (keyup.enter)="
                onClick(message().body ? 'detailsButton' : 'actionButton')
              "
            >
              {{
                !message().body ? message().actionButton?.text : 'Learn more'
              }}
            </a>
          }
          @if (message().canDismiss && !message().body) {
            <a
              class="text-default cursor-pointer text-base font-medium underline opacity-65"
              [ngClass]="{
                'order-first':
                  message().dismissButton?.text?.toLowerCase() === 'yes',
              }"
              (click)="onClick('dismissButton')"
              tabindex="0"
              (keyup.enter)="onClick('dismissButton')"
            >
              {{ message().dismissButton?.text || 'Dismiss' }}
            </a>
          }
        </div>
      }
    </div>
  </div>

  <!-- Actions -->
  <div class="relative flex">
    @if (!message().isRead) {
      <button
        class="h-6 min-h-6 w-6"
        mat-icon-button
        matTooltip="Mark as read"
        (click)="sendReadRequest()"
      >
        <span class="h-2 w-2 rounded-full bg-accent"></span>
      </button>
    }
    <button
      class="h-6 min-h-6 w-6"
      mat-icon-button
      matTooltip="Remove"
      (click)="onClick('dismissButton')"
    >
      <mat-icon class="icon-size-4" svgIcon="heroicons_solid:x-mark" />
    </button>
  </div>
</div>
